import gql from "graphql-tag"

const GET_CUSTOM_PAYMENT_CONFIG = gql`
  query getCustomPaymentConfig($id: ID!) {
    getCustomPaymentConfig(id: $id) {
      id
      created
      updated
      baseUrl
      authUrl
    }
  }
`

export default GET_CUSTOM_PAYMENT_CONFIG
